import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Box, Typography, FormControlLabel } from "@material-ui/core";
import { LogoGGD } from "../../components/Logo";

const GoGetDocWaitlist = ({ formField }) => {
  const { t } = useTranslation();

  return (
    <Box p={2}>
      <Typography component="h2" variant="h5" paragraph>
        <strong>{t("schedule.ggd_teaser.title")}</strong>
      </Typography>
      <Box mb={2}>
        <LogoGGD height="25px" />
      </Box>
      <Typography paragraph>{t("schedule.ggd_teaser.intro_text")}</Typography>
      <FormControlLabel
        labelPlacement="end"
        control={formField}
        label={t("schedule.ggd_teaser.form.waitlist.label")}
      />
    </Box>
  );
};

GoGetDocWaitlist.propTypes = {
  formField: PropTypes.element.isRequired
};

export { GoGetDocWaitlist };
